import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { buildHttpParams } from 'src/app/helpers/build-state-params';
import { environment } from 'src/environments/environment';
import { IFinishedOutOrderHistory } from 'src/models/History';
import { FinishedOutOrder, OutOrderComments } from 'src/models/OutOrder';

interface FinishedOutOrderApiResponseInterface {
  count: number,
  values: FinishedOutOrder[]
}
interface OutOrderCommentsApiResponseInterface {
  outOrderId: string,
  commentsQty: number,
}

@Injectable({
  providedIn: 'root'
})
export class OutOrderDataSourceV3Service {

  constructor(private http: HttpClient) { }

  getFinishedOutOrders(params?): Promise<FinishedOutOrderApiResponseInterface> {
    return this.http.get<FinishedOutOrderApiResponseInterface>(environment.v3BaseUrl + `/api/v3/admin-desktop/out-orders/finished`, { params }).toPromise();
  }

  getFinishedOutOrderDetails(outOrderId: string): Promise<FinishedOutOrder> {
    return this.http.get<FinishedOutOrder>(environment.v3BaseUrl + `/api/v3/admin-desktop/out-orders/finished/${outOrderId}`).toPromise();
  }

  getFinishedOutOrderCommentsByOrderId(outOrderId: string): Promise<OutOrderComments[]> {
    return this.http.get<OutOrderComments[]>(environment.v3BaseUrl + `/api/v3/admin-desktop/out-orders-comments/${outOrderId}`).toPromise();
  }

  getFinishedOutOrderComments(outOrderIds: string[]): Observable<OutOrderCommentsApiResponseInterface[]> {
    const queryParams = { outOrderIds: outOrderIds };
    const params = buildHttpParams(queryParams);
    return this.http.get<OutOrderCommentsApiResponseInterface[]>(environment.v3BaseUrl + `/api/v3/admin-desktop/out-orders-comments/count`, { params });
  }
  
  getFinishedOutOrderHistory(outOrderId: string): Promise<IFinishedOutOrderHistory[]> {
    return this.http.get<IFinishedOutOrderHistory[]>(environment.v3BaseUrl + `/api/v3/admin-desktop/out-orders/${outOrderId}/event-history`).toPromise();
  }
}
